var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CritereBase',{attrs:{"selected":_vm.selected},on:{"select":(value) => _vm.$emit('select', value)}},[_c('SelectProduiCerealeComponent',{attrs:{"label":"Produit emblavé","labelCols":{ md: '6' },"fetch":true,"actif":true,"value":_vm.params[1].valeur},on:{"input":(value) => _vm.inputParam(1, value)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }